<template>
     <div class="left-menu-header">
              <ul class="app-list">
                <li class="onhover-dropdown">
                  <div class="app-menu"> <i data-feather="folder-plus"><vue-feather type="folder-plus" @click="collapseFilter()"></vue-feather></i></div>
                  <ul class="onhover-show-div left-dropdown" :class="filtered?'active':''">
                    <li> <router-link to="/app/file_manager">File Manager </router-link></li>
                    <li> <router-link to="/app/kanbanBoard"> Kanban board</router-link></li>
                    <li> <router-link to="/pages/social-app"> Social App</router-link></li>
                    <li> <router-link to="/app/bookmark"> Bookmark</router-link></li>
                  </ul>
                </li>
              </ul>
              <ul class="header-left"> 
                <li class="onhover-dropdown"><span class="f-w-600">Dashboard</span><span><vue-feather class="middle" type="chevron-down"></vue-feather></span>
                  <ul class="onhover-show-div left-dropdown">
                    <li> <router-link to="/dashboards/default"> Default </router-link></li>
                    <li><router-link to="/dashboards/e-commerce"> Ecommerce</router-link></li>
                  </ul>
                </li>
                <li class="onhover-dropdown"><span class="f-w-600">Application</span><span><vue-feather class="middle" type="chevron-down"></vue-feather></span>
                  <ul class="onhover-show-div left-dropdown">
                    <li class="flyout-right"><a href="javascript:void(0)">Project</a>
                      <ul>
                        <li><router-link to="/project/project-list"> Project List</router-link></li>
                        <li><router-link to="/project/create-Project"> Project Create</router-link></li>
                      </ul>
                    </li>
                    <li><router-link to="/app/file_manager"> File manager </router-link></li>
                    <li><router-link to="/app/kanbanBoard"> kanban </router-link></li>
                    <li class="flyout-right"><a href="javascript:void(0)">Ecommerce</a>
                      <ul>
                        <li> <router-link to="/ecommerce/product">Product</router-link></li>
                        <li> <router-link to="/ecommerce/details/1">Product Page</router-link></li>
                        <li> <router-link to="/ecommerce/productlist">Product List</router-link></li>
                        <li> <router-link to="/ecommerce/payment/details">Payment Details</router-link></li>
                        <li> <router-link to="/ecommerce/order/history">Order History</router-link></li>
                        <li> <router-link to="/ecommerce/invoice">Invoice</router-link></li>
                        <li> <router-link to="/ecommerce/cart" >Cart</router-link></li>
                        <li> <router-link to="/ecommerce/wishlist">Wishlist</router-link></li>
                        <li> <router-link to="/ecommerce/checkout">Checkout</router-link></li>
                        <li> <router-link to="/ecommerce/pricing">Pricing </router-link></li>
                      </ul>
                    </li>
                    <li class="flyout-right"><a href="javascript:void(0)">Email</a>
                      <ul>
                        <li> <router-link to="/email/email-inbox"> Mail Inbox </router-link></li>
                        <li> <router-link to="/email/read">Read Mail</router-link></li>
                        <li> <router-link to="/email/email-compose">Compose</router-link></li>
                      </ul>
                    </li>
                    <li class="flyout-right"><a href="javascript:void(0)">Chat</a>
                      <ul>
                        <li><router-link to="/app/chat">Chat App</router-link></li>
                        <li> <router-link to="/app/video-chat">Video Chat</router-link></li>
                      </ul>
                    </li>
                    <li class="flyout-right"><a href="javascript:void(0)">Users</a>
                      <ul>
                        <li> <router-link to="/users/profile">User Profile</router-link></li>
                        <li> <router-link to="/users/edit">Users Edit</router-link></li>
                        <li> <router-link to="/users/cards">User Cards</router-link></li>
                      </ul>
                    </li>
                    <li><router-link to="/app/bookmark">Bookmarks</router-link></li>
                    <li><router-link to="/app/contact">Contacts</router-link></li>
                    <li><router-link to="/pages/social-app">Social App</router-link></li>
                  </ul>
                </li>
                <li class="onhover-dropdown"> <span class="f-w-600">More pages</span><span><vue-feather class="middle" type="chevron-down"></vue-feather></span>
                  <ul class="onhover-show-div left-dropdown">
                    <li><router-link to="/pages/sample-page">Sample Page</router-link></li>
                    <li><router-link to="/pages/internationalization"> Internationalization</router-link></li>
                  </ul>
                </li>
               
              </ul>
            </div>
</template>
<script>
export default {
    data(){
        return{
             filtered: false,
        }
    },
    methods:{
          collapseFilter() {
        this.filtered = !this.filtered;
      },
    }
}
</script>